import React from "react";
import Eyebrow from "./Eyebrow";
import Reveal from "./Reveal";
import SplitText from "./SplitText";

const SectionHeading = ({
  eyebrow,
  index,
  title,
  lead,
  align = "left",
  action,
  className = "",
}) => {
  const alignment =
    align === "center"
      ? "items-center text-center"
      : align === "right"
      ? "items-end text-right"
      : "items-start text-left";

  return (
    <div
      className={`flex flex-col gap-5 ${alignment} ${className} ${
        action ? "lg:flex-row lg:items-end lg:justify-between" : ""
      }`}
    >
      <div className={`flex flex-col gap-5 ${alignment}`}>
        {eyebrow && (
          <Reveal>
            <Eyebrow index={index}>{eyebrow}</Eyebrow>
          </Reveal>
        )}
        {title && <SplitText as="h2" text={title} className="t-title max-w-3xl" />}
        {lead && (
          <Reveal delay={0.12}>
            <p className="t-lead max-w-prose">{lead}</p>
          </Reveal>
        )}
      </div>
      {action && <Reveal delay={0.18}>{action}</Reveal>}
    </div>
  );
};

export default SectionHeading;
